import { Payer } from "@wingspanhq/wingspan-api-sdk";
import { wsNameV3 } from "@wingspanhq/utils/dist/name/wsNameV3";

/**
 * A client's name for display — the v3 replacement for calling `wsName` on a
 * v1 `IPayerResponse`.
 *
 * A `Payer` is the payee's side of the relationship, so its identity goes in as
 * `payeeOwnedData`. `wsNameV3` reads `companyName` / `legalName` from an
 * `account`, which a contractor never has for a client (that identity lives on
 * the client's own account behind an information-sharing grant), so resolution
 * falls to the relationship's company name, then its display name, then the
 * email.
 *
 * `wsNameV3` resolves to `undefined` when a client carries none of those —
 * which happens, since a contractor's view of a client is sparse — so this
 * falls back to the id rather than let a page title render blank.
 *
 * Individual profile fields belong straight off the `Payer` (see
 * [[ClientInfoPanel]]) rather than through the name helper.
 */
export const selectorPayerDisplayName = (payer: Payer): string =>
  wsNameV3({
    payeeOwnedData: {
      payerExternalId: payer.externalId,
      payerDisplayName: payer.profile?.displayName,
      payerCompanyName: payer.profile?.company?.doingBusinessAs
    },
    ...(payer.email ? { principalPerson: { email: payer.email } } : {})
  }).resolvedName ??
  payer.id ??
  "";
